// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2495":"057e6b73","4962":"c5bf1a39","7024":"b141f7e3","7433":"f0c76437","7540":"dc4988c5","8335":"3e983091","8457":"094be0a1","9925":"4c894f48"}[chunkId] + ".chunk.css";
};